import { Navigation } from 'lucide-react';
import busIconUrl from '@/assets/transport-icons/bus.png';
import cngIconUrl from '@/assets/transport-icons/cng.png';
import rickshawIconUrl from '@/assets/transport-icons/rickshaw.png';
import rideShareIconUrl from '@/assets/transport-icons/ride-share.png';
import vanIconUrl from '@/assets/transport-icons/van.png';
import walkIconUrl from '@/assets/transport-icons/walk.png';
import { cn } from '@/lib/utils';
import { TRANSPORT_TYPE_CODE } from '@/constants/transportTypes';
import type { MoTravelTransportType } from '../types/moTravel.types';

const TRANSPORT_ICON_URL_BY_CODE: Record<string, string> = {
  [TRANSPORT_TYPE_CODE.RICKSHAW]: rickshawIconUrl,
  [TRANSPORT_TYPE_CODE.VAN_OR_TEMPO]: vanIconUrl,
  [TRANSPORT_TYPE_CODE.BUS_CAR_OR_SHIP]: busIconUrl,
  [TRANSPORT_TYPE_CODE.CNG_OR_MOTOR_BIKE]: cngIconUrl,
  [TRANSPORT_TYPE_CODE.WALK]: walkIconUrl,
  [TRANSPORT_TYPE_CODE.RIDE_SHARE]: rideShareIconUrl,
};

interface MoTransportIconProps {
  transportType: MoTravelTransportType;
  className: string;
}

export function MoTransportIcon({ transportType, className }: MoTransportIconProps) {
  const iconUrl = transportType.code ? TRANSPORT_ICON_URL_BY_CODE[transportType.code] : undefined;
  if (!iconUrl) return <Navigation className={className} aria-hidden />;

  return (
    <span
      className={cn(
        'inline-block shrink-0 bg-current mask-contain mask-center mask-no-repeat',
        className,
      )}
      style={{ maskImage: `url(${iconUrl})` }}
      aria-hidden
    />
  );
}
